import { dataLayer } from 'analytics/data-layer';
import { useEffect, useRef } from 'react';
import { useWtrSelector } from 'redux/hooks';
import { createProductImpression } from 'redux/middleware/analytics/actions-to-track/products-and-components/product-grid-impressions';
import { productImpressions } from 'redux/middleware/analytics/actions-to-track/products-and-components/product-impressions';
import { getProductByLineNumber } from 'redux/modules/entities/selectors/products';

export const useCarouselGA = ({ list, products }) => {
  const hasTracked = useRef(false);
  const selectProductsByLineNumbers = state => {
    return products
      .map(({ searchProduct }) => getProductByLineNumber(state, searchProduct))
      .map((productInCarousel, index) =>
        createProductImpression(state, productInCarousel, list, index),
      );
  };

  const data = useWtrSelector(selectProductsByLineNumbers);

  useEffect(() => {
    if (hasTracked.current) return;

    hasTracked.current = true;
    dataLayer.push(productImpressions(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
